import React, { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { ArrowLeft, Shield } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { useNewVerification } from '@/hooks/useNewVerification';
import EmailVerificationCard from './EmailVerificationCard';
import SelfieVerificationCard from './SelfieVerificationCard';
import TeamApprovalCard from './TeamApprovalCard';
import VerifiedBenefitsScreen from './VerifiedBenefitsScreen';
import VerificationHeader from './VerificationHeader';

const NewVerificationSteps = () => {
  const navigate = useNavigate();
  const { profileData } = useAuth();
  const { verification, getCurrentVerification, createVerification, isLoading } = useNewVerification();

  // Se o usuário já está verificado, mostrar tela de benefícios
  if (profileData?.verification_level === 'full') {
    return <VerifiedBenefitsScreen />;
  }

  useEffect(() => {
    const initializeVerification = async () => {
      let existingVerification = await getCurrentVerification();
      
      if (!existingVerification) {
        existingVerification = await createVerification();
      }
    };

    initializeVerification();
  }, [getCurrentVerification, createVerification]);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-black via-gray-900 to-black flex items-center justify-center">
        <div className="text-center">
          <div className="w-12 h-12 bg-gradient-to-br from-luxury-gold to-luxury-gold/80 rounded-full flex items-center justify-center mx-auto mb-4 animate-pulse">
            <Shield className="w-6 h-6 text-black" />
          </div>
          <p className="text-white text-sm">Preparando verificação...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-black via-gray-900 to-black pb-24 md:pb-6">
      {/* Mobile Header */}
      <VerificationHeader />

      {/* Main Content */}
      <div className="px-4 py-6 max-w-4xl mx-auto">
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-gradient-to-br from-luxury-gold to-luxury-gold/80 rounded-full flex items-center justify-center mx-auto mb-4">
            <Shield className="w-8 h-8 text-black" />
          </div>
          <h2 className="text-2xl font-bold text-white mb-2">Verificação em 3 Etapas</h2>
          <p className="text-white/60">Complete as etapas: Email → Selfie → Aprovação da Equipe</p>
        </div>

        {/* Verification Cards */}
        <div className="grid gap-6 md:grid-cols-2">
          <EmailVerificationCard 
            verification={verification} 
            onUpdate={() => getCurrentVerification()} 
          />
          <SelfieVerificationCard 
            verification={verification} 
            onUpdate={() => getCurrentVerification()} 
          />
          <div className="md:col-span-2">
            <TeamApprovalCard
              verification={verification} 
              onUpdate={() => getCurrentVerification()} 
            />
          </div>
        </div>

        {/* Privacy Notice */}
        <div className="mt-8 p-4 bg-white/5 rounded-lg border border-white/10">
          <div className="flex items-center gap-2 text-sm text-white/60">
            <Shield className="w-4 h-4 text-luxury-gold flex-shrink-0" />
            <span>Seus dados são protegidos e usados apenas para verificação de identidade</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewVerificationSteps;